import { Box } from "@chakra-ui/react";
import { colors, responsive, VStack } from "goi_common";
import React from "react";

export default function GuideSummary({ summary }: { summary: any }) {
  return (
    <VStack
      className="body_16_m lg_subtitle_16_b gray800"
      css={responsive({
        margin: { base: "0 24px", lg: "0" },
        padding: { base: "20px", lg: "18px 32px" },
        background: colors.warmGray150,
        borderRadius: "10px",
      })}
      gap="10px"
    >
      <Box className="subtitle_16_b gray900">{summary.title}</Box>
      <Box className="body_16_m gray700">
        {summary.description.map((res: string) => (
          <Box key={res}>{res}</Box>
        ))}
      </Box>
    </VStack>
  );
}
